module.exports = __webpack_public_path__ + "assets/images/03_98305e89d97b43abad020903223b0e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/03.png
// module id = 115
// module chunks = 0